import React from 'react';

function BulletPointsAndLinks({category="", bulletPointsAndLinks=[]}) {
  return (
    <div>
      <h2>{category}</h2>
      <ul>
        {bulletPointsAndLinks.map((bulletPointAndLinks, index) => (

          <li className='list-with-padding-bottom'>
              <h3 className="header-one">{bulletPointAndLinks.bulletPoint}</h3>
              <ul>
                {bulletPointAndLinks.links.map((link) => (
                  <li><a href={link.url} target="_blank" rel="noreferrer">{link.display}</a></li>
                ))}
              </ul>
          </li>
          ))}
      </ul>
    </div>
  );
}

// Export the component so it can be used in other files
export default BulletPointsAndLinks;